import { FacetItem, registerWidget, IWidgetSettings, IWidget, IWidgetDefinition, SubFilter } from '../../common/core';
import { CheckFacetData } from '../checkwidget/checkfacetdata';
import { ITextFacetSettings, ITextFacetState } from './settings';

var template = require("./textfacet.html");
var styles = require("./textfacet.scss").toString();

export class TextFacetItem extends FacetItem {
    label?: string; // not comming from API, but can be passed manually

    /**
     * From range
     * comes when "field": "cdu_num@ranges:50|100|300"
     */
    from?: number;
    /**
     * To range
     */
    to?: number;
}

class TextFacetData extends CheckFacetData<TextFacetItem> {
    // ---------------------- ellapse\collapse button -----------------------
    show_more: boolean;
    mode: 'single_option' | 'normal';

    // ---------------------- search facet input ----------------------------
    showMoreSearchingSpinner = false;
    showSearchTermInput = false;
    searchTermString = "";
    allSearchTermResults = [];
    highligted: number = null;
    addMoreListMaxHeight: number;
    missedCount: number = 0;
    totalCount: number = 0;
    searchMore: boolean; // show a message on very bottom if not all "More" options are shown 
    showMoreList = false;
    moreLoading = false;

    /**
     * Top position of more input (in px)
     */
    moreInputTop: number;

    /**
     * true - uses from/to
     * false - uses term
     */
    rangeMode = false;
    skipSearchTerms = false;

    prentNextScroll = false;
    termsShowPlugin = null;
    scrollPlugin = null;
    checkScroll: boolean;

    lastTerms: TextFacetItem[];

    /**
     * Promise for separate request
     */
    separateRequestPromise: Promise<void>;

    /**
     * View theme
     */
    theme?: string;

    constructor(public widget: IWidget<TextFacetData, ITextFacetSettings, ITextFacetState>) {
        super(widget);

        // hide search results block after click outside except of search input
        this.widget.service['zone'].runOutsideAngular(() => {
            document.addEventListener('mouseup', this.globalMoreMouseupHandler);
            document.addEventListener('keydown', this.globalMoreKeydownHandler);
        });

        // hide more dropdown after scroll (only for grid mode)
        var closeMoreListHandler = () => {
            this.widget.service['zone'].run(() => {
                if (this.widget.data.prentNextScroll) {
                    this.widget.data.prentNextScroll = false;
                    return;
                }
                if (this.widget.data.isGridMode() && widget.data.showSearchTermInput && widget.data.checkScroll) {
                    this.widget.data.closeMoreInput();
                }
            });
        };
        this.scrollPlugin = {

            afterViewInit: function (plugin) {
                this._el = plugin.$element.nativeElement;
                this._attachHandler();
            },
            onDestroy: function (plugin) {
                this._detachHandler();
                this._el = null;
            },
            _attachHandler: function () {
                if (this._el) {
                    this._el.addEventListener('scroll', closeMoreListHandler);
                }
            },
            _detachHandler: function () {
                if (this._el) {
                    this._el.removeEventListener('scroll', closeMoreListHandler);
                }
            }
        }

        // scroll grid container to the bottom after click on more
        this.termsShowPlugin = {
            _scroll: function () {
                var cEl = this._el.parentNode.parentNode.querySelector('.sj-widget-content-container');
                if (cEl) {
                    widget.data.prentNextScroll = true;
                    cEl.scrollTop = cEl.scrollHeight;
                }
            },
            _refreshTopPosition: function () {
                if (!widget.data.isGridMode()) {
                    return;
                }

                // refresh top position
                var moreEl = this._getMoreEl();
                if (moreEl) {
                    var addFilterContainer = moreEl;
                    while (addFilterContainer) {
                        if (addFilterContainer.classList.contains('sjtextf-add-filter-container')) {
                            break;
                        }
                        addFilterContainer = addFilterContainer.parentNode;
                    }
                    if (addFilterContainer) {
                        var el = addFilterContainer;
                        var top = widget.data.theme ? 34 : (el.offsetHeight - 2);
                        while (el && !el.classList.contains('sj-widget-content-container')) {
                            top += el.offsetTop;
                            el = el.offsetParent;
                        }
                        console.warn('refreshTopPosition scrollTop:' + el.scrollTop);
                        top -= el.scrollTop;
                        widget.data.moreInputTop = top;
                    }
                }
            },
            _refreshMaxHeight: function () {
                var moreEl = this._getMoreEl();
                if (moreEl) {
                    var offsetParent = moreEl.parentNode;
                    var addMoreOffset = offsetParent.offsetTop;
                    while (offsetParent = offsetParent.offsetParent) {
                        addMoreOffset += offsetParent.offsetTop;
                    }
                    widget.data.addMoreListMaxHeight = document.body.scrollHeight - addMoreOffset - 40
                        - (widget.data.searchMore ? (widget.data.theme ? 0 : 30) : 0);
                }
            },
            _getMoreEl: function () {
                var moreEl = this._el;
                while (moreEl) {
                    if (moreEl.classList.contains('sjtextf')) {
                        break;
                    }
                    moreEl = moreEl.parentNode;
                }
                moreEl = moreEl.querySelector('.sjtextf-more-link');
                return moreEl;
            },
            afterViewInit: function (plugin) {
                this._el = plugin.$element.nativeElement;

                if (plugin.context?.show) {
                    if (plugin.context?.scroll) {
                        this._scroll();
                    }
                    this._refreshTopPosition();
                }
            },
            onChanges: function (plugin) {
                if (!this._el) {
                    this._el = plugin.$element.nativeElement;
                }
                if (this._el) {
                    setTimeout(() => {
                        if (plugin.context?.show) {
                            if (plugin.context?.scroll) {
                                this._scroll();
                            }
                            this._refreshTopPosition();
                        }
                    });
                }

            },
            onDestroy: function (plugin) {
                this._el = null;
            },
        }

        this.theme = this.widget.service.getGlobalOptions().theme;

        if (this.widget.settings.onInit) {
            this.widget.settings.onInit(this.widget);
        }
    }

    showme(): boolean {
        var res = super.showme() && this.terms && (this.terms.length || this.widget.settings.maxFacets === 0) && !!this.widget.data.field;
        if (res && this.widget.settings.isActive) {
            res = this.widget.settings.isActive(this.widget);
        }
        return res;
    }

    destroy() {
        this.widget.service['zone'].runOutsideAngular(() => {
            document.removeEventListener('mouseup', this.globalMoreMouseupHandler);
            document.removeEventListener('keydown', this.globalMoreKeydownHandler);
        });
    }

    globalMoreMouseupHandler = (e) => {
        this.widget.service['zone'].run(() => {
            if (this.showSearchTermInput) {
                var el = <HTMLElement>e.target;

                while (el) {
                    if (el.classList && (el.classList.contains('sjtextf-searchResult-overlay') || el.classList.contains('sjtextf-search-input-wrapper'))) {
                        return;
                    }
                    if (el.parentNode) {
                        el = <HTMLElement>el.parentNode;
                    } else {
                        break;
                    }
                }

                this.widget.service['zone'].run(() => {
                    this.widget.data.closeMoreInput();
                });
            }
        });
    };

    closeMoreInput() {
        if (this.moreTermsToAddAfterClose?.length) {
            this.setTerms(this.lastTerms, this.otherTermsCount);
            this.moreTermsToAddAfterClose = null;
        }
        this.widget.data.showSearchTermInput = false;
        this.widget.data.showMoreList = false;
        this.widget.data.checkScroll = true;
    }

    // number of facets for "More"
    get moreMaxFacets() {
        return this.widget.settings.moreMaxFacets || 20;
    }

    // number of facets to show
    get maxFacets() {
        if (this.widget.settings.maxFacets === 0) {
            return 0;
        }
        return this.widget.settings.maxFacets || 5;
    }

    globalMoreKeydownHandler = (event) => {
        this.widget.service['zone'].run(() => {
            this._globalMoreKeydownHandler(event);
        });
    };

    _globalMoreKeydownHandler(event) {
        if (this.showSearchTermInput) {
            var key = event.which;
            switch (key) {
                case 13:
                    // Key enter.
                    var itemToSelect = this.allSearchTermResults[this.highligted];
                    if (itemToSelect) {
                        this.onSearchTermClicked(itemToSelect);
                    }
                    event.preventDefault(); // prevent form submit (for embed view)
                    break;
                case 38:
                    // Key up.
                    if (this.highligted > 0) {
                        this.highligted--;
                    }
                    break;
                case 40:
                    // Key down.
                    if (this.highligted < this.allSearchTermResults.length - 1) {
                        this.highligted++;
                    }
                    break;
            }
        }
    }

    onMoreClick() {
        this.showMoreSearchingSpinner = true;
        this.searchTermString = "";
        this.highligted = 0;
        this.moreLoading = true;

        this.checkScroll = false;

        this.requestFacets(this.moreMaxFacets, (terms, other) => {
            terms = this.adjustFacets(terms, '');
            this.showMoreSearchingSpinner = false;
            this.showSearchTermInput = true;

            if (this.termsShowPlugin) {
                this.termsShowPlugin._refreshMaxHeight();
            }

            this.onFacetsRecieved(terms);
            this.searchMore = !!other;

            var input = <HTMLElement>this.widget.widgetDiv.element.nativeElement.getElementsByClassName("sjtextf-search-input")[0];
            this.skipSearchTerms = true;
            if (input) {
                input.focus();
            }
            this.skipSearchTerms = false;
            this.moreLoading = false;

            setTimeout(() => {
                this.checkScroll = true;
            });
        }, true);
    }

    isGridMode() {
        return !!this.widget['grid'];
    }

    _searchTermResultsTimeout;
    searchTermResults(searchString, show, delay?) {
        clearTimeout(this._searchTermResultsTimeout);

        if (this.skipSearchTerms) {
            return;
        }
        if (show === false) {
            this.showMoreList = false;
            return;
        }
        if (show === true) {
            this.showMoreList = true;
        }

        this.moreLoading = true;

        if (delay) {
            this._searchTermResultsTimeout = setTimeout(() => {
                this._searchTermResults(searchString);
            }, 200);
        } else {
            this._searchTermResults(searchString);
        }
    }

    _searchTermResultsXhr;
    _searchTermResults(searchString) {
        var filterExp = "*" + searchString + "*";

        if (this._searchTermResultsXhr) {
            this._searchTermResultsXhr['_aborted'] = true;
            if (this._searchTermResultsXhr.abort) {
                this._searchTermResultsXhr.abort();
            }
        }

        if (this.termsShowPlugin) {
            this.termsShowPlugin._refreshTopPosition();
        }

        this.checkScroll = false;

        this.filterFacets(this.moreMaxFacets, filterExp, (terms, other) => {
            this._searchTermResultsXhr = null;
            terms = this.adjustFacets(terms, searchString || '');
            this.searchMore = !!other;
            this.onFacetsRecieved(terms);
            this.showSearchTermInput = true;

            this.moreLoading = false;

            setTimeout(() => {
                this.checkScroll = true;
            });
        }).then(xhr => {
            this._searchTermResultsXhr = xhr;
        });
    }

    adjustFacets(terms: { count: number, term: string, label?: string }[], moreFilter?: string) {
        if (this.widget.settings.adjustFacets) {
            return this.widget.settings.adjustFacets(this.widget, terms, moreFilter || '');
        }
        return terms;
    }

    onSearchTermClicked(t) {
        this.widget.data.check(t);
    }

    clickBeforeCheck(evt, event) {
        if (this.isRadio()) {
            // radiobutton
            if (this.widget.state.selected && this.widget.state.selected[this.getValueFromTerm(evt)]) {
                if (!this.widget.settings.radioEmpty) {
                    // make all unselected
                    if (event) {
                        event.preventDefault();
                    }
                    return false;
                }
            }
        }
    }

    getValueFromTerm(term: TextFacetItem) {
        if (term.to !== undefined || term.from !== undefined) {
            var from: string | number = term.from;
            var to: string | number = term.to;

            if (from === undefined) {
                from = '';
            }
            if (to === undefined) {
                to = '';
            }

            return `${from}|${to}`;
        }
        return term.term;
    }

    isRadio() {
        return this.widget.settings.radio;
    }

    _check(term: TextFacetItem) {
        // var hasChecked = this.widget.state.selected && !!Object.keys(this.widget.state.selected).length;
        var termValue = this.getValueFromTerm(term);

        //core logic
        if (this.isRadio()) {
            var newState = {};
            if (!this.widget.state.selected || !this.widget.state.selected[termValue]) {
                newState[termValue] = true
            }
            if (Object.keys(newState).length) {
                this.widget.state.selected = newState;
            } else {
                delete this.widget.state.selected;
            }
        } else {
            // checkbox
            var isSelectedMode = this.isSelectedMode();
            if (this.widget.state.selected && this.widget.state.selected[termValue] === isSelectedMode) {
                delete this.widget.state.selected[termValue];
                if (!Object.keys(this.widget.state.selected).length) {
                    delete this.widget.state.selected;
                }
            } else {
                if (!this.widget.state.selected) {
                    this.widget.state.selected = {};
                }
                this.widget.state.selected[termValue] = isSelectedMode;
            }
        }

        if (this.widget.settings.showNull && this.widget.settings.showAll !== false) {
            delete this.widget.state.all;
            /*
            if (!hasChecked && this.widget.state.all !== false) {
                this.widget.state.nullable = false;
            }
            */
        }
    }

    _onChange() {
        if (this.widget.settings.onChange) {
            this.widget.settings.onChange(this.widget);
        }
    }

    _setState() {
        if (this.widget.settings.setState !== false) {
            this.widget.service.setState(this.widget.settings.ignoreQuery);
        }
    }

    _trackAction(term: TextFacetItem) {
        this.widget.service.getConfig().trackAction(`${this.widget.type}:toggle`, this.widget, {
            isSelected: (this.widget.state.selected || {})[this.getValueFromTerm(term)] || false,
            label: term.label || term.term,
            facetLabel: this.widget.settings.name
        });
    }

    moreTermsToAddAfterClose = null;
    check(term: TextFacetItem) {
        // `setTimeout` used to fix issue in IE when `checked` goes to not sync state with [checked]
        setTimeout(() => {
            this._check(term);
            this._onChange();
            this._setState();

            if (this.theme && this.showSearchTermInput) {
                if (!this.moreTermsToAddAfterClose) {
                    this.moreTermsToAddAfterClose = [];
                }
                var checked = this.isTermChecked(term);
                if (checked) {
                    this.moreTermsToAddAfterClose.push(term);
                } else {
                    this.moreTermsToAddAfterClose = this.moreTermsToAddAfterClose.filter(t => {
                        return t.term !== term.term;
                    });
                }
            } else {
                this.closeMoreInput();
            }

            this._trackAction(term);
        });
    }

    otherTermsCount = null;
    setTerms(terms: TextFacetItem[], otherTermsCount: number) {
        this.lastTerms = JSON.parse(JSON.stringify(terms));
        this.otherTermsCount = otherTermsCount;

        this.rangeMode = !!terms.find(item => item.from !== undefined || item.to !== undefined);

        if (this.rangeMode) {
            this.widget.state.rangeMode = true;
        } else {
            delete this.widget.state.rangeMode;
        }

        var resultTerms = this.addMissedSelectedItems(terms, otherTermsCount);
        resultTerms = this.adjustFacets(resultTerms);

        // if widget.data.terms contains only 1 item then only show that
        this.setMode(resultTerms);

        this.terms = resultTerms;

        if (this.terms) {
            this.terms.forEach(t => {
                t['_count'] = this.shortNum(t.count);
            });
        }
    }

    addMissedSelectedItems(terms, otherTermsCount) {
        //adds selected terms that are not in facet
        var max_to_show = this.maxFacets;
        var selected = JSON.parse(JSON.stringify(this.widget.state.selected || {}));
        terms.forEach(t => {
            delete selected[this.getValueFromTerm(t)];
        });
        Object.keys(selected).forEach(t => {
            terms.push(this.addMissedSelectedTerm(t));
        })
        this.show_more = terms.length > max_to_show || otherTermsCount > 0;
        var resultTerms = terms.slice(0, max_to_show);

        //add selected terms that are outside of first max_to_show elements
        if (max_to_show < terms.length) {
            terms.slice(max_to_show, terms.length).filter((t) => {
                if (this.widget.state.selected && this.widget.state.selected[this.getValueFromTerm(t)] === this.isSelectedMode())
                    resultTerms.push(t);
            });
        }

        return resultTerms;
    }

    public addMissedSelectedTerm(term: string) {
        var res = {
            term: term,
            count: 0
        };

        if (this.allSearchTermResults) {
            var matchedTerm = this.allSearchTermResults.find(t => {
                return t.term == term;
            });
            if (matchedTerm) {
                res.count = matchedTerm.count;
            }
        }

        return res;
    }

    // if widget.data.terms contains only 1 item then only show that
    public setMode(resultTerms) {
        if (resultTerms.length == 1 && this.getSelArray(this.isSelectedMode()).length == 0 && !this.widget.settings.showNull && !this.missedCount) {
            this.mode = 'single_option';
        } else {
            this.mode = 'normal';
        }
    }

    /**
     * Get global query promise
     * Can be overridden in widgets
     */
    public getGlobalQuery(): Promise<string> {
        return this.widget.service.awaitGlobalQuery(this.widget, true, false);
    }

    /*
     * Called when widget has at least one selected item
     */
    requestFacets(size, callback: (terms: any[], other: number) => void, ignoreVisibleItems = false) {
        this.getGlobalQuery().then(query => {
            var q = query;

            if (ignoreVisibleItems && this.terms.length) {
                size += this.terms.length;
            }
            var request = {
                per_page: 0,
                query: q,
                facets: this.fieldWithSort,
                max_facet_values: size
            };
            var default_fields = this.widget.service.seriesParam.default_fields;
            if (default_fields) {
                if (typeof default_fields == 'function') {
                    default_fields = default_fields(this.widget.service);
                }
                request['default_fields'] = default_fields;
            }

            this._requestFacets(request).then((response: any) => {
                var facetPart = response.facets && response.facets[this.fieldWithSort] || {};
                this.missedCount = facetPart.missing;
                this.totalCount = facetPart.total;

                var terms = facetPart.terms || [];

                if (ignoreVisibleItems) {
                    var termsToIgnore = {};
                    this.terms.forEach(t => {
                        termsToIgnore[t.term] = 1;
                    });
                    terms = terms.filter(t => {
                        return !termsToIgnore[t.term];
                    });
                }

                callback(terms, facetPart.other || 0);
            });
        });
    }

    _requestFacets(request) {
        return new Promise((resolve, reject) => {
            this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, request, resolve, reject);
        });
    }

    /*
     * Called in "+ More"
     */
    filterFacets(size: number, term_filter: string, callback, ignoreVisibleItems = true) {
        return new Promise<void>((resolve, reject) => {
            const facets = this.fieldWithSort + '@filter:' + term_filter;
            this.getGlobalQuery().then(query => {
                var skipQ = (ignoreVisibleItems && this.terms.length) ?
                    this.widget.service.helpers.formatQueryPart(this.widget.data.field, this.terms.map(t => t.term), '=') : '';

                var request = {
                    per_page: 0,
                    query: skipQ ? `NOT ${skipQ} ${query}` : query,
                    facets: facets,
                    max_facet_values: size
                };
                var default_fields = this.widget.service.seriesParam.default_fields;
                if (default_fields) {
                    if (typeof default_fields == 'function') {
                        default_fields = default_fields(this.widget.service);
                    }
                    request['default_fields'] = default_fields;
                }

                var xhr = this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, request, (response) => {
                    var facetPart = response.facets && response.facets[facets] || {};
                    callback(facetPart.terms || [], facetPart.other || 0);
                });
                resolve(xhr);
            });
        });
    }

    onFacetsRecieved(terms) {
        var termsToShow = terms.filter((el) => {
            var isTermInFilter = this.terms.find((t) => {
                return this.getValueFromTerm(t) === this.getValueFromTerm(el)
            });
            return typeof isTermInFilter === "undefined";
        });
        this.allSearchTermResults = termsToShow;
    }

    /*
     * Returns `true` if should make a separate request to load facets, `false` - means to use data from `onData` call
     */
    get shouldMakeSeparateRequest() {
        return this.getSelArray(this.isSelectedMode()).length || this.widget.state.nullable === false || this.widget.state.all === false;
    }

    checkAll() {
        // `setTimeout` used to fix issue in IE when `checked` goes to not sync state with [checked]
        setTimeout(() => {
            if (this.widget.settings.showNull) {

                if (super.isAllChecked()) { // if no items selected than we can only toggle `state.all`
                    if (this.widget.state.all === false) {
                        delete this.widget.state.all;
                    } else {
                        this.widget.state.all = false;
                    }
                } else { // if some items are selected than we can only turn on `All` checkbox and delete `state.all`
                    delete this.widget.state.all;
                    this.clearCheck(false);
                }

                this._onChange();
                this._setState();
            } else {
                super.checkAll();
            }
        });
    }

    isAllChecked() {
        if (this.widget.settings.showNull) {
            return super.isAllChecked() && this.widget.state.all !== false;
        } else {
            return super.isAllChecked();
        }
    }

    isAllDisabled() {
        return this.isAllChecked() && !this.widget.settings.showNull;
    }

    getSeparateFacetsSize() {
        return this.widget.service.seriesParam.max_facet_values || 20;
    }

    isTermChecked(term) {
        var termValue = this.widget.data.getValueFromTerm(term);
        var isSelectedMode = this.isSelectedMode();
        if (this.widget.state.selected && this.widget.state.selected[termValue] !== undefined) {
            var res = this.widget.state.selected[termValue];
            return res;
        }
        return !isSelectedMode;
    }

    /**
     * Returns default checked behavior
     * true - default is unchecked
     * false - default is checked
     */
    isSelectedMode() {
        return true;
        // return !this.widget.settings.inverse;
    }

    getSelectedQuery() {
        if (this.widget.settings.ignoreQuery || !this.widget.settings.field)
            return;

        var queryParts = [];

        var sel = this.getSelArray(true);
        var unsel;
        if (!sel.length) {
            unsel = this.getSelArray(false);
        } else {
            unsel = [];
        }

        var isSelectedMode = this.isSelectedMode();
        if (sel.length || unsel.length) {
            var selection = isSelectedMode ? sel : unsel;
            var prefix = isSelectedMode ? '' : 'NOT ';
            if (this.rangeMode || this.widget.state.rangeMode) {
                var fieldName = this.field.split('@')[0];
                var rangeQueries = [];
                selection.forEach(s => {
                    var q = [];
                    var [from, to] = s.split('|');

                    if (from === to) {
                        q.push(this.widget.service.helpers.formatQueryPart(fieldName, from, '='));
                    } else {
                        if (from) {
                            q.push(this.widget.service.helpers.formatQueryPart(fieldName, from, '>='));
                        }
                        if (to) {
                            q.push(this.widget.service.helpers.formatQueryPart(fieldName, to, '<='));
                        }
                    }
                    var fq = q.join(' ');
                    if (q.length > 1) {
                        fq = `${prefix}(${fq})`;
                    }
                    rangeQueries.push(fq);
                });

                queryParts.push(rangeQueries.join(isSelectedMode ? ' OR ' : ' '));
            } else {
                queryParts.push(prefix + this.widget.service.helpers.formatQueryPart(this.fieldWithoutAt, selection, '='));
            }
            if (this.widget.settings.showNull) {
                if (isSelectedMode) {
                    if (this.widget.state.nullable !== false) {
                        queryParts.push(`NOT set:${this.widget.service.helpers.escapeQueryText(this.fieldWithoutAt)}`);
                    }
                } else {
                    if (this.widget.state.nullable === false) {
                        queryParts.push(`set:${this.widget.service.helpers.escapeQueryText(this.fieldWithoutAt)}`);
                    }
                }

            }
        } else if (this.widget.state.nullable === false && this.widget.state.all === false) {
            queryParts.push(`set:zzz`); // same as sjweb
        } else {
            if (this.widget.state.nullable === false) {
                queryParts.push(`set:${this.widget.service.helpers.escapeQueryText(this.fieldWithoutAt)}`);
            }
            if (this.widget.state.all === false) {
                queryParts.push(`NOT set:${this.widget.service.helpers.escapeQueryText(this.fieldWithoutAt)}`);
            }
        }

        return queryParts.join(isSelectedMode ? ' OR ' : ' ');
    }

    get fieldWithSort() {
        let sort = '';
        if (this.widget.settings.sort && this.widget.settings.sort !== 'count.desc') {
            sort = `@sort:${this.widget.settings.sort}`;
        }

        return `${this.field}${sort}`;
    }

    beforeSearch() {
        this.separateRequestPromise = null;
        if (this.shouldMakeSeparateRequest) {
            //in other words, we have a query... can't trust main search facets
            this.separateRequestPromise = new Promise<void>(resolve => {
                if (this.theme && this.showSearchTermInput) {
                    resolve();
                    return;
                }
                this.requestFacets(this.getSeparateFacetsSize(), (facets, other) => {
                    this.setTerms(facets, other);
                    this.widget.refreshGridContainerHeightIfNecessary();
                    resolve();
                });
            });
        }
    }
}

var TextFacetWidgetDefinition: IWidgetDefinition<TextFacetData, ITextFacetSettings, ITextFacetState> = {
    init(widget) {
        widget.data = new TextFacetData(widget);

        /*
        if (widget.settings.inverse) {
            widget.service.captureMessage('Textfacet: inverse');
        }
        */
    },
    defaultState: {},
    getFacets(widget) {
        if (/*!widget.data.shouldMakeSeparateRequest &&*/ widget.data.field) {
            return [widget.data.fieldWithSort];
        }
    },
    getSubFilters(widget) {

        if (widget.data.isRadio() && !widget.settings.radioEmpty) {
            return null;
        }

        // cases:
        //  selected facets
        //  selected facets + null
        //  null (null-all)
        //  nou null (all-null)

        function createFilter(filter: { value: string, label: string }): SubFilter {
            return {
                value: filter.value,
                label: filter.label,
                widgetId: widget.id,
                widgetLabel: typeof widget.settings.name == 'function' ? widget.settings.name(widget) : widget.settings.name
            };
        }

        var selectedKeys = widget.data.getSelArray();

        var filters = selectedKeys.map(f => {
            var term = widget.data.terms.find(x => widget.data.getValueFromTerm(x) == f);
            return createFilter({
                value: f,
                label: term ? (term.label || term.term) : f
            });
        });

        if (widget.settings.showNull) {
            //1. all+null --- nothing
            //2. all      --- not null
            //3. null     --- null
            //4. selected+null -- selected+null

            // #3 #4 add `null` filter
            if ((selectedKeys.length || widget.state.all === false) && widget.state.nullable !== false) {
                filters.push(createFilter({
                    value: null,
                    label: 'null'
                }));
            }

            // #2 add `not null` filter
            if (!selectedKeys.length && widget.state.all !== false && widget.state.nullable === false) {
                filters.push(createFilter({
                    value: null,
                    label: 'is set'
                }));
            }
        }

        return filters;
    },
    removeSubFilter(widget, filter: SubFilter) {
        if (filter.value) {
            if (widget.state.selected) {
                delete widget.state.selected[filter.value];
                if (!Object.keys(widget.state.selected).length) {
                    delete widget.state.selected;
                }
            }
            if (widget.settings.showNull && (!widget.state.selected || !Object.keys(widget.state.selected).length)) {
                delete widget.state.nullable;
            }
        } else {
            switch (filter.label) {
                case 'null':
                    if (!widget.state.selected || !Object.keys(widget.state.selected).length) {
                        delete widget.state.all;
                    } else {
                        widget.state.nullable = false;
                    }
                    break;
                case 'not null':
                    delete widget.state.nullable;
                    break;
            }
        }
        if (widget.settings.onChange) {
            widget.settings.onChange(widget);
        }
    },
    beforeSearch(widget) {
        widget.data.beforeSearch();
    },
    onData(widget, response) {
        if (response.success) {
            const facetPart = response && response.facets ? response.facets[`${widget.data.fieldWithSort}`] : null;
            if (widget.data.shouldMakeSeparateRequest) {
                if (widget.data.separateRequestPromise && facetPart && facetPart.terms) {
                    widget.data.separateRequestPromise.then(() => {
                        widget.data.terms.filter(term => {
                            if (term.count === 0) {
                                var matchedTerm = facetPart.terms.find(t => t.term == term.term);
                                if (matchedTerm) {
                                    term.count = matchedTerm.count;
                                    term._count = widget.data.shortNum(term.count);
                                }
                            }
                        });
                    });
                }
            } else {
                var facetFields = [], otherTermsCount = 0;
                if (facetPart) {
                    facetFields = facetPart.terms;
                    otherTermsCount = facetPart.other;
                    widget.data.missedCount = facetPart.missing;
                    widget.data.totalCount = facetPart.total;
                } else {
                    widget.data.missedCount = 0;
                    widget.data.totalCount = 0;
                }
                if (facetFields.length || widget.data.terms.length) {
                    widget.data.setTerms(facetFields, otherTermsCount);
                }
            }
        } else {
            widget.data.setTerms([], 0);
        }
    },
    getQuery(widget): string {
        return widget.data.getSelectedQuery();
    },
    destroy(widget) {
        widget.data.destroy && widget.data.destroy();
    },
    stateInit: function (widget) {
        widget.data.stateInit();
    },
    notActiveAction: function (widget, action) {
        switch (action) {
            case 'beforeSearch':
                // if widget is not active, then should drop currently shown/loaded terms
                widget.data.setTerms([], 0);
                break;
        }
    },
    template: template,
    styles: styles,
    classNames: ['sj-widget-rel']
}

export { TextFacetWidgetDefinition, TextFacetData };